<template>
  <footer>
    <v-container :fluid="true" class="footer__container">
      <v-row class="footer__container--width-max mx-auto">
        <v-col cols="12" class="list-menu-wrapper">
          <div
            class="footer-link flex-column mb-md-9 flex-wrap flex-md-row d-flex align-center justify-space-between"
          >
            <router-link
              :to="homeLink"
              class="text-primary text-decoration-none text-link-hover"
              tabindex="1"
            >
              Home
            </router-link>

            <a
              class="text-primary text-decoration-none text-link-hover"
              tabindex="1"
              :href="faqLink"
              target="_blank"
            >
              FAQs
              <v-icon size="12" color="#FFF">mdi-open-in-new</v-icon>
            </a>

            <span
              class="text-link text-link-hover"
              tabindex="1"
              @keydown.enter="
                openModalWithParams('DialogContentTermsAndConditions', 800)
              "
              @click="
                openModalWithParams('DialogContentTermsAndConditions', 800)
              "
            >
              Terms & conditions
            </span>

            <span
              class="text-link text-link-hover"
              tabindex="1"
              @keydown.enter="openModalWithParams('DialogContentCookies', 800)"
              @click="openModalWithParams('DialogContentCookies', 800)"
            >
              Cookies
            </span>

            <span
              class="text-link text-link-hover"
              tabindex="1"
              @keydown.enter="
                openModalWithParams('DialogContentAccessibility', 800)
              "
              @click="openModalWithParams('DialogContentAccessibility', 800)"
            >
              Accessibility
            </span>

            <a
              class="text-primary text-decoration-none text-link-hover"
              tabindex="1"
              :href="PRIVACY_POLICY_LINK"
              target="_blank"
            >
              Privacy policy
              <v-icon size="12" color="#FFF">mdi-open-in-new</v-icon>
            </a>

            <span
              class="text-link text-link-hover"
              tabindex="1"
              @keydown.enter="
                openModalWithParams('DialogContentModernSlaveryAct', 800)
              "
              @click="openModalWithParams('DialogContentModernSlaveryAct', 800)"
            >
              Modern slavery act
            </span>
            <BaseLink :to="contactUs" :target="'_blank'"> Contact us </BaseLink>
          </div>
        </v-col>
        <v-col cols="12" class="copy-right d-flex justify-space-between">
          <div class="d-none d-md-flex align-center font-14">
            <img
              class="logo mr-4"
              src="@/assets/images/logo-transparent.svg"
              width="163"
              height="40"
              alt="Paymentshield White Logo"
            />
            © Paymentshield Limited {{ currentYear }}
          </div>
          <div class="d-flex align-center mx-auto ml-md-auto mr-md-0">
            <span class="d-none d-md-inline-block font-14">Follow us</span>
            <v-btn
              icon
              class="ml-2 d-inline-block twitter-btn white--text"
              tabindex="1"
              @click="linkToTwitter"
              @keydown.enter="linkToTwitter"
              aria-label="twitter"
            >
              <v-icon>mdi-twitter</v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12">
          <p class="fca-wrapper">
            Paymentshield Limited (registered number 02728936) is a company
            registered in England and Wales at Southport Business Park, Wight
            Moss Way, Southport, PR8 4HQ. VAT registration no: GB 447284724.
            Telephone calls may be recorded for security purposes and monitored
            under our quality control procedures. Paymentshield Limited is
            authorised and regulated by the Financial Conduct Authority (FCA)
            under registration No. 312708.See the Financial Services Register
            for further details.
          </p>
          <div class="d-md-none text-center">
            <img
              class="logo mr-4"
              src="@/assets/images/logo-transparent.svg"
              width="163"
              height="40"
              alt="Paymentshield White Logo"
            />
            <p class="font-14">© Paymentshield Limited {{ currentYear }}</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
import {
  generateLinkContactUs,
  generateLinkHome,
  generateFAQSLink,
  PRIVACY_POLICY_LINK,
} from "@/common/navigating";
import BaseLink from "@/components/BaseComponents/BaseLink";
import { HOME_LINK } from "@/constants/home.constants";
import { DIALOG_MODULE, QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "TheFooter",
  components: {
    BaseLink,
  },
  data() {
    return {
      faqLink: "",
      TWITTER_LINK: HOME_LINK.TWITTER,
      PRIVACY_POLICY_LINK,
    };
  },
  watch: {
    $route() {
      this.faqLink = generateFAQSLink();
    },
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["productId"]),
    homeLink() {
      return generateLinkHome(this.isSelfServe, this.$route);
    },
    currentYear() {
      return new Date().getFullYear();
    },
    contactUs() {
      const location = generateLinkContactUs(this.isSelfServe, this.$route);
      location.query = {
        ["productId"]: this.productId,
      };
      return location;
    },
    ...mapGetters(QUESTIONS_MODULE, ["isSelfServe"]),
  },
  mounted() {
    this.faqLink = generateFAQSLink();
  },
  methods: {
    ...mapMutations(DIALOG_MODULE, ["showModal"]),
    linkToTwitter() {
      window.open(this.TWITTER_LINK, "_blank");
    },
    openModalWithParams(dialogComponentName, dialogWidth) {
      const payload = { dialogWidth, dialogComponentName };
      this.showModal(payload);
    },
  },
};
</script>
<style lang="scss">
.footer__container {
  background: var(--v-primary-base);
  color: #fff;
  padding: 46px 0 24px !important;
  &--width-max {
    max-width: 954px;
  }
  .list-menu-wrapper {
    padding: 0;
    a,
    .text-link {
      color: #fff;
      text-decoration: none;
      font-size: 14px;
      &:hover {
        text-decoration: underline !important;
        cursor: pointer;
      }
    }
  }
  .copy-right {
    padding: 0;
  }
  .icon--twitter {
    margin-left: 16px;
    .v-icon {
      color: #fff;
      font-size: 26px;
    }
  }
  .logo {
    max-width: 160px;
  }
  .fca-wrapper {
    padding-top: 11px;
    font-size: 11px;
  }
  .v-btn.twitter-btn {
    margin-right: -5px;
    &:hover::before {
      opacity: 0.1;
      background-color: currentColor;
      transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
    }
  }
}

@media screen and (max-width: ($grid-breakpoints-sm - 1)) {
  .footer__container {
    padding: 62px 40px 18px 40px !important;
    .list-menu-wrapper {
      a,
      .text-link {
        width: 100%;
        text-align: center;
        display: block;
        font-size: 23px;
        margin-bottom: 28px;
      }
    }
    .v-btn.twitter-btn {
      margin-right: 0;
    }
    .icon--twitter {
      margin: -9px 0 14px 0;
    }
    .logo {
      margin: 41px 0 32px 0 !important;
      max-width: 194px;
    }
    .fca-wrapper {
      font-size: 14px;
      text-align: center;
    }
  }
}

@media screen and (orientation: landscape) {
  .footer-link {
    padding: 0;
    gap: 10px;
  }
}
</style>
